import { Component, OnInit, OnChanges, Output, Input, EventEmitter } from '@angular/core';
import { DatepicketLocalizationService, I18n } from '../../../services/datepicket-localization-service.service';
import { NgbDateStruct, NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
declare var $: any;
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es-MX';
import { NewTask, DelTask } from '../../../models/tarea/tarea.module';
import { Router } from '@angular/router';
import { TareasService } from '../../../services/tareas.service';
import { CategoryService } from '../../../services/category.service';
import { UserService } from '../../../services/user.service';
import { FileItem } from '../../../models/adduser/adduser/adduser.module';
import { HttpClient, HttpEventType } from '@angular/common/http';

registerLocaleData(localeEs, 'es-Mx');

@Component({
  selector: 'app-editar-tarea',
  templateUrl: './editar-tarea.component.html',
  styleUrls: ['./editar-tarea.component.css']
})
export class EditarTareaComponent implements OnInit {
  cat;
  activ;
  token;
  listas;
  email;
  info;
  loading: boolean = false;
  loadingusers: boolean = false;
  loadingdoc: boolean = false;
  aform: boolean = false;
  tipo_fecha: boolean = false;
  model: NgbDateStruct;
  model2: NgbDateStruct;
  time = { hour: 13, minute: 30 };
  time2 = { hour: 13, minute: 30 };
  //  time2 = {hour: 13, minute: 30};
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  task: NewTask;
  archivos: FileItem[] = [];
  mensaje: string;
  public options: Object = {
    placeholderText: 'Escribe un comentario',
    charCounterCount: false
  }
  @Input() edit_tarea: any;
  @Output() cerrarFormularioEdit: EventEmitter<any>;
  @Output() otrafuncion = new EventEmitter<any>();
  constructor(private _userService: UserService, private _categoryService: CategoryService, public router: Router,
    private calendar: NgbCalendar, public formatter: NgbDateParserFormatter, private _tareasService: TareasService) {
    this.cerrarFormularioEdit = new EventEmitter();
    this.otrafuncion = new EventEmitter();
    //this.edit_tarea = " ";
    //this.edit_tarea = this._categoryService.edit_tarea;
    this.task = new NewTask(0, "", 0, "", "", "", "", "", 0, 0, false, [], "#007bffff");
    const user = this._userService.getIdentity();
    this.email = user.email;
    const token = this._userService.getToken();
    this.token = token;

  }

  ngOnInit(): void {
    $('select').selectpicker();
    setTimeout(() => {
      $('select').selectpicker('refresh');
    }, 1500);
  }
  ngOnChanges(): void {
    //console.log("entra funcion");
    //console.log(this.edit_tarea);
    if (this.edit_tarea[0].privada == 1) {
      this.edit_tarea[0].privado = true;
    } else {
      this.edit_tarea[0].privado = false;
    }
    this.task = new NewTask(this.edit_tarea[0].id_tarea, this.edit_tarea[0].nombre, 0, "", this.email, "", "", this.edit_tarea[0].comentarios, 0, 0, this.edit_tarea[0].privado, [], this.edit_tarea[0].color);
    //console.log(this.task);
    this.getInfo(this.task);
    this.model = null;
    this.model2 = null;
    this.time = null;
    this.time2 = null;

    let fecha = this.edit_tarea[0].date;
    let splits = fecha.split("-");
    //console.log(splits[0]);
    let anio = parseInt(splits[0], 10);
    let mes = parseInt(splits[1], 10);
    let dia = parseInt(splits[2], 10);
    //console.log(mes);
    let fecha2 = this.edit_tarea[0].date2;
    let splits2 = fecha2.split("-");

    let anio2 = parseInt(splits2[0], 10);
    let mes2 = parseInt(splits2[1], 10);
    let dia2 = parseInt(splits2[2], 10);

    let hora = this.edit_tarea[0].hora;
    let splits_hora = hora.split(":");
    let h1 = parseInt(splits_hora[0], 10);
    let m1 = parseInt(splits_hora[1], 10);

    let hora2 = this.edit_tarea[0].hora2;
    let splits_hora2 = hora2.split(":");
    let h2 = parseInt(splits_hora2[0], 10);
    let m2 = parseInt(splits_hora2[1], 10);
    this.model = new NgbDate(anio, mes, dia);
    this.model2 = new NgbDate(anio2, mes2, dia2);
    this.time = { hour: h1, minute: m1 };
    this.time2 = { hour: h2, minute: m2 };
    this.fromDate = this.calendar.getToday();
    this.cat = this._categoryService.category;
    this.activ = this._categoryService.activ;
    const token = this._userService.getToken();
    this.token = token;
    const user = this._userService.getIdentity();
    //console.log(this.cat);
    //console.log(this.activ);
    this.usuarios_estatus();
  }

  cerrar() {
    this.otrafuncion.emit();
    this.cerrarFormularioEdit.emit();
  }

  usuarios_estatus() {
    this._tareasService.taskformAdd(this.cat, this.token).subscribe(
      response => {
        this.listas = response;
        $('select').selectpicker('refresh');
        //console.log(response);
      },
      error => {
        const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(error);
          }
        );
        console.log(error);
      }
    );
  }
  fecha_uno() {
    this.tipo_fecha = false;
    this.edit_tarea[0].tipo_fecha = 0;
  }
  fecha_dos() {
    this.tipo_fecha = true;
    this.edit_tarea[0].tipo_fecha = 1;
  }
  fileEvent(e) {
    for (let i = 0; i < e.target.files.length; i++) {
      this.archivos.push(new FileItem(e.target.files[i]));
    }
  }
  eliminararchivo(i) {
    this.archivos.splice(i, 1);
  }
  limpiararchivos() {
    this.mensaje = '';
    this.archivos = [];
  }
  getInfo(task) {
    //console.log(task);
    this._tareasService.taskInfo(task, this.token).subscribe(
      response => {
        this.info = response;
        $('select').selectpicker();
        setTimeout(() => {
          $('select').selectpicker('refresh');
        }, 1500);
        //console.log(this.info);
      },
      error => {
        const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(error);
          }
        );
        console.log(error);
      }
    );
  }
  onSubmit(form) {
    this.loading = true;
    this.task.tipo = form.value.fecha_form;
    this.task.comentario = form.value.comentario;
    if (this.task.tipo == 0) {
      let date = form.value.dp.year + '-' + form.value.dp.month + '-' + form.value.dp.day;
      let hora1 = form.value.algo.hour + ':' + form.value.algo.minute + ':00';
      let hora2 = form.value.algo2.hour + ':' + form.value.algo2.minute + ':00';
      let fecha = date + ' ' + hora1;
      let fecha2 = date + ' ' + hora2;
      this.task.fecha_inicio = fecha;
      this.task.fecha_termino = fecha2;
    } else {
      let fecha = form.value.dp.year + '-' + form.value.dp.month + '-' + form.value.dp.day + " 00:00:00";
      let fecha2 = form.value.dp2.year + '-' + form.value.dp2.month + '-' + form.value.dp2.day + " 00:00:00";
      this.task.fecha_inicio = fecha;
      this.task.fecha_termino = fecha2;
    }
    this._tareasService.taskEdit(this.task, this.token).subscribe(
      response => {
        this.otrafuncion.emit();
        this.getInfo(this.task);
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: response.message,
          showConfirmButton: false,
          timer: 1500
        });
        this.loading = false;
        //console.log(response);
      },
      error => {
        const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(error);
          }
        );
        console.log(error);
        this.loading = false;
      }
    );

  }
  onSubmitUsers(form) {
    this.loadingusers = true;
    //console.log(form.value);
    //console.logconsole.log(this.task);
    this._tareasService.taskEditUsers(this.task, this.token).subscribe(
      response => {
        this.getInfo(this.task);
        this.otrafuncion.emit();
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: response.message,
          showConfirmButton: false,
          timer: 1500
        });
        this.loadingusers = false;
        //console.log(response);
      },
      error => {
        const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
        this._userService.register_error(message_error, this.token).subscribe(
          response2 => {
            Swal.fire({
              position: 'top-end',
              icon: 'warning',
              title: response2.message,
              showConfirmButton: false,
              timer: 2000
            });
          },
          error => {
            console.log(error);
          }
        );
        console.log(error);
        this.loadingusers = false;
      }
    );

  }
  onSubmitDoc(form) {
    if (this.archivos.length != 0) {
      for (let i = 0; i < this.archivos.length; i++) {
        this._tareasService.subir_archivos(this.archivos[i].archivo, this.task.id, this.token).subscribe(
          response => {
            if (response.type === HttpEventType.UploadProgress) {
              this.archivos[i].progreso = Math.round(response.loaded / response.total * 100);
            } else if (response.type === HttpEventType.Response) {
              //console.log(response.body);
              this.mensaje = "Se subieron los archivos, correctamente";
              this.getInfo(this.task);
              this.otrafuncion.emit();
            }
          },
          error => {
            const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
            this._userService.register_error(message_error, this.token).subscribe(
              response2 => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'warning',
                  title: response2.message,
                  showConfirmButton: false,
                  timer: 2000
                });
              },
              error => {
                console.log(error);
              }
            );
            //console.log(error);
            //console.log(error.status);
            if (error.status == 413) {
              this.mensaje = "No se pudo subir el archivo el archivo es demaciado grande";
            } else {
              this.mensaje = "No se pudo subir el archivo";
            }
          }
        );
      }

    } // end if
    //this.archivos = [];
  }
  del_doc(id) {
    Swal.fire({
      title: '¿Eliminar el documento?',
      text: "Desea eliminar el documento de la tarea",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {

        const task = new DelTask(id, id);
        this._tareasService.DelDoc(task, this.token).subscribe(
          response => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1500
            });
            this.getInfo(this.task);
            this.otrafuncion.emit();
          },
          error => {
            const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
            this._userService.register_error(message_error, this.token).subscribe(
              response2 => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'warning',
                  title: response2.message,
                  showConfirmButton: false,
                  timer: 2000
                });
              },
              error => {
                console.log(error);
              }
            );
            console.log(error);
          }
        );

      }
    });
  }
  del_user_proyect(tarea, id_us) {

    Swal.fire({
      title: '¿Eliminar Usuarios?',
      text: "Desea eliminar al usuario de la tarea",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.value) {

        const task = new DelTask(this.task.id, id_us);
        // console.log(task);
        this._tareasService.DelUser(task, this.token).subscribe(
          response => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1500
            });
            this.getInfo(this.task);
            this.otrafuncion.emit();
          },
          error => {
            const message_error = 'Mensaje: ' + <any>error.message + 'Nombre: ' + <any>error.name + 'Status: ' + <any>error.status + 'Texto Status: ' + <any>error.statusText;
            this._userService.register_error(message_error, this.token).subscribe(
              response2 => {
                Swal.fire({
                  position: 'top-end',
                  icon: 'warning',
                  title: response2.message,
                  showConfirmButton: false,
                  timer: 2000
                });
              },
              error => {
                console.log(error);
              }
            );
            console.log(error);
          }
        );

      }
    });
  }

}
